import src from "IMAGE";
export default { src, width: 264, height: 58, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
